var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "audit-style" },
    [
      _c(
        "el-aside",
        { staticClass: "aside-left", attrs: { width: "180px" } },
        [
          _c(
            "div",
            { staticClass: "page-input" },
            [
              _c(
                "el-input",
                {
                  attrs: {
                    type: "number",
                    size: "small",
                    placeholder: "输入页码"
                  },
                  model: {
                    value: _vm.gotoPage,
                    callback: function($$v) {
                      _vm.gotoPage = $$v
                    },
                    expression: "gotoPage"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { slot: "append" },
                      on: {
                        click: function($event) {
                          return _vm.handleContractPageClick(_vm.gotoPage)
                        }
                      },
                      slot: "append"
                    },
                    [_vm._v("Go!")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("p", { staticClass: "nav-tab" }, [
            _c(
              "span",
              {
                staticClass: "nav-item",
                class: _vm.navTab === 1 ? "active" : "",
                on: {
                  click: function($event) {
                    _vm.navTab = 1
                  }
                }
              },
              [_vm._v("状态")]
            ),
            _c(
              "span",
              {
                staticClass: "nav-item",
                class: _vm.navTab === 2 ? "active" : "",
                on: {
                  click: function($event) {
                    _vm.navTab = 2
                  }
                }
              },
              [_vm._v("预览")]
            )
          ]),
          _vm.navTab === 1
            ? [
                _c(
                  "div",
                  {
                    staticClass: "sec-content",
                    style: { height: _vm.listHeight + "px" }
                  },
                  [
                    _c("div", { staticClass: "nav-item" }, [
                      _c("label", [_vm._v("文件名称")]),
                      _c(
                        "p",
                        {
                          staticClass: "font-ellipsis",
                          attrs: { title: _vm.detailInfo.contractName }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.detailInfo.contractName) +
                              "\n          "
                          )
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "nav-item" }, [
                      _c("label", [_vm._v("文件编号")]),
                      _c(
                        "p",
                        {
                          staticClass: "font-ellipsis",
                          attrs: { title: _vm.detailInfo.applyNo }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.detailInfo.applyNo) +
                              "\n          "
                          )
                        ]
                      ),
                      _c("label", [_vm._v("文件来源")]),
                      _c(
                        "p",
                        {
                          staticClass: "font-ellipsis",
                          attrs: { title: _vm.detailInfo.ebqUserName }
                        },
                        [
                          _vm._v(
                            "\n            名称：" +
                              _vm._s(_vm.detailInfo.ebqUserName) +
                              "\n          "
                          )
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "nav-item" }),
                    _vm._l(_vm.detailInfo.signInfos, function(item, index) {
                      return [
                        _c("div", { key: index, staticClass: "nav-item" }, [
                          _c("label", [
                            _vm._v(
                              "签署方" + _vm._s(index + 1) + "\n              "
                            ),
                            item.signStatus == 1
                              ? _c(
                                  "span",
                                  { staticClass: "bar-status status-blue" },
                                  [_vm._v("已签署")]
                                )
                              : item.signStatus == 2
                              ? _c(
                                  "span",
                                  { staticClass: "bar-status status-red" },
                                  [_vm._v("拒签")]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "bar-status status-orange" },
                                  [_vm._v("未签署")]
                                )
                          ]),
                          _c("p", [
                            _vm._v(
                              "\n              名称：" +
                                _vm._s(item.fullName) +
                                " "
                            ),
                            _c("br"),
                            _vm._v("\n              证件号："),
                            _c("br"),
                            _vm._v(
                              _vm._s(item.identityCardMask) + "\n            "
                            )
                          ])
                        ])
                      ]
                    })
                  ],
                  2
                )
              ]
            : _vm._e(),
          _vm.navTab === 2
            ? [
                _c(
                  "div",
                  {
                    staticClass: "list-pages",
                    style: { height: _vm.listHeight + "px" }
                  },
                  [
                    _vm._l(_vm.convertInfo.items, function(i) {
                      return [
                        _c(
                          "div",
                          {
                            key: i,
                            class: _vm.currentData === i ? "active" : "",
                            on: {
                              click: function($event) {
                                _vm.currentData = i
                              }
                            }
                          },
                          [
                            _vm.fileInfo.sign
                              ? _c("img", {
                                  attrs: {
                                    src: _vm.ApiMethods.FileOperController.convertDetail_url(
                                      _vm.fileInfo.sign,
                                      _vm.fileInfo.ts,
                                      _vm.fileInfo.fileType,
                                      "png",
                                      _vm.fileInfo.targetId,
                                      i,
                                      _vm.convertInfo.docHash || ""
                                    )
                                  }
                                })
                              : _vm._e(),
                            _c("span", { staticClass: "p-index" }, [
                              _vm._v(_vm._s(i))
                            ])
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-main",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.contractLoading,
              expression: "contractLoading"
            }
          ],
          ref: "contrBody",
          staticClass: "main-box",
          style: { height: _vm.mainHeight + "px" }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.convertInfo.items > 0,
                  expression: "convertInfo.items > 0"
                }
              ],
              ref: "contrScro",
              staticClass: "contr-pages-scro"
            },
            [
              _c("p", { staticClass: "con-pageindex" }, [
                _vm._v(
                  _vm._s(_vm.currentData) + "/" + _vm._s(_vm.convertInfo.items)
                )
              ]),
              _vm.fileInfo.sign && _vm.convertInfo && _vm.convertInfo.items
                ? _c("img", {
                    attrs: {
                      src: _vm.ApiMethods.FileOperController.convertDetail_url(
                        _vm.fileInfo.sign || "",
                        _vm.fileInfo.ts || "",
                        _vm.fileInfo.fileType || "",
                        "png",
                        _vm.fileInfo.targetId || "",
                        _vm.currentData || "",
                        _vm.convertInfo.docHash || ""
                      )
                    },
                    on: {
                      loadstart: function($event) {
                        _vm.contractLoading = true
                      },
                      load: function($event) {
                        _vm.contractLoading = false
                      }
                    }
                  })
                : _vm._e(),
              _vm.currentData > 1
                ? _c(
                    "div",
                    {
                      staticClass: "pre",
                      on: {
                        click: function($event) {
                          _vm.currentData == Math.max(--_vm.currentData, 1)
                        }
                      }
                    },
                    [_c("i", { staticClass: "el-icon-arrow-left" })]
                  )
                : _vm._e(),
              _vm.convertInfo.items > _vm.currentData
                ? _c(
                    "div",
                    {
                      staticClass: "next",
                      style: { right: _vm.nextLeft },
                      on: {
                        click: function($event) {
                          _vm.currentData ==
                            Math.max(++_vm.currentData, _vm.convertInfo.items)
                        }
                      }
                    },
                    [_c("i", { staticClass: "el-icon-arrow-right" })]
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _c(
        "el-aside",
        {
          staticClass: "aside-right",
          class: "approve-aside",
          attrs: { width: "250px" }
        },
        [
          [
            !_vm.isInDingTalk
              ? _c(
                  "div",
                  { staticClass: "bottom_textarea" },
                  [
                    _c("span", [_vm._v("审批意见：")]),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: "5",
                        resize: "none",
                        autofocus: true,
                        size: "small",
                        maxlength: 100,
                        placeholder: "请输入审批意见"
                      },
                      model: {
                        value: _vm.refuseModel.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.refuseModel, "reason", $$v)
                        },
                        expression: "refuseModel.reason"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "p",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "small" },
                    on: { click: _vm.showInfo }
                  },
                  [_vm._v("审批详情")]
                )
              ],
              1
            ),
            !_vm.isInDingTalk
              ? [
                  _c(
                    "p",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.clickHanldeAuditRefuse(1)
                            }
                          }
                        },
                        [_vm._v("同意")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "p",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.clickHanldeAuditRefuse(2)
                            }
                          }
                        },
                        [_vm._v("拒绝")]
                      )
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm.isInDingTalk
              ? [
                  _c(
                    "p",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: {
                            type: "primary",
                            size: "small",
                            loading: _vm.approLoading
                          },
                          on: {
                            click: function($event) {
                              return _vm.examineHandle()
                            }
                          }
                        },
                        [_vm._v("审批")]
                      )
                    ],
                    1
                  )
                ]
              : _vm._e()
          ]
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticClass: "apprave-info",
          attrs: {
            visible: _vm.dialogAuditDetailVisible,
            title: "审批详情",
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogAuditDetailVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  !_vm.isInDingTalk
                    ? [
                        _vm.auditDetailInfo &&
                        Object.keys(_vm.auditDetailInfo).length &&
                        (_vm.auditDetailInfo.fileFlow.length ||
                          _vm.auditDetailInfo.sealFlow.length)
                          ? _c("audit-detail", {
                              attrs: { auditor: _vm.auditDetailInfo }
                            })
                          : _c("el-empty", {
                              attrs: { description: "暂无数据" }
                            })
                      ]
                    : _vm._e(),
                  _vm.isInDingTalk
                    ? _c("ding-audit-detail", {
                        attrs: {
                          auditor: _vm.auditDetailInfo,
                          applyInfo: _vm.detailInfo
                        }
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogAuditRefuseVisible,
            title: "拒绝原因",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogAuditRefuseVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  { staticStyle: { position: "relative" } },
                  [
                    _c("el-input", {
                      ref: "textareaReason",
                      attrs: {
                        type: "textarea",
                        rows: "5",
                        resize: "none",
                        autofocus: true,
                        size: "small",
                        maxlength: 100,
                        placeholder: "请输入拒绝原因,100字以内"
                      },
                      on: {
                        blur: function($event) {
                          return _vm.handleBlur()
                        }
                      },
                      model: {
                        value: _vm.refuseModel.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.refuseModel, "reason", $$v)
                        },
                        expression: "refuseModel.reason"
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          bottom: "10px",
                          right: "10px",
                          color: "red"
                        }
                      },
                      [_vm._v(_vm._s(_vm.refuseModel.wordNumber) + "/100")]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "el-col",
                { staticStyle: { height: "24px" }, attrs: { span: 24 } },
                [
                  _vm.refuseModel.errorMessage
                    ? _c("p", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.refuseModel.errorMessage) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _c(
            "p",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.dialogAuditRefuseVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.clickHandleRefuseSubmit()
                    }
                  }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bfa51fa4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfa51fa4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/applySign/audit.vue
// module id = hquR
// module chunks = 32